import React from 'react';
import TimelineUI from './TimelineUI';
import { getFieldMapping } from './service/utils';
var Timeline = function (_a) {
    var fields = _a.fields;
    var decades = getFieldMapping({ fields: fields }).decades;
    return React.createElement(TimelineUI, { decades: decades });
};
export default Timeline;
